<script setup lang="ts">
defineProps<{
  selected?: boolean;
  changeColor?: boolean;
  hideBorder?: boolean;
}>();
</script>
<template>
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="1"
      y="1"
      width="38"
      height="38"
      rx="3"
      fill="#021B27"
      stroke="#02877F"
      stroke-width="2"
      :class="{
        hidden: hideBorder
      }"
    />
    <rect
      x="13"
      y="22"
      width="4"
      height="20"
      rx="1.5"
      transform="rotate(-90 13 22)"
      :class="{
        'fill-online': changeColor
      }"
      fill="#00CAAA"
    />
    <path
      d="M7.17378 20.3738C6.94984 20.1749 6.94984 19.8251 7.17378 19.6262L14.418 13.1917C14.7404 12.9052 15.25 13.1342 15.25 13.5655L15.25 26.4345C15.25 26.8658 14.7404 27.0948 14.418 26.8083L7.17378 20.3738Z"
      fill="#00CAAA"
      stroke="#00CAAA"
      :class="{
        'fill-online stroke-online': changeColor
      }"
    />
  </svg>
</template>
